import React from 'react';

import MaskedInput from 'react-text-mask';
//import NumberFormat from 'react-number-format';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import InputAdornment from "@material-ui/core/InputAdornment";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import AccountBalance from '@material-ui/icons/AccountBalance';
import CardTravel from '@material-ui/icons/CardTravel';

import PictureUpload from "components/CustomUpload/PictureUpload.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import { store } from '../../../redux/store';

import Countries from '../../../assets/countries.json'
import { ADD_CUSTOMER_FORM_CHANGE, SET_USER_LIST } from '../../../redux/types';
import ReactSelect from '../../../components/Select/ReactSelect';
import Api from '../../../api/Api.js';
import ImageEndpoints from '../../../api/ImageEndpoints';
import UserEndpoints from '../../../api/UserEndpoints';
import UserImage from '../../../components/Image/UserImage';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

export const AccountNumberInputLocal = ({ inputRef, ...other }) => {
    var mask = [/[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            style={{ textTransform: 'uppercase', ...other.style }}
            mask={mask}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

export const AccountNumberInputForeign = ({ inputRef, ...other }) => {
    var mask = [/[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, 'F'];
    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            style={{ textTransform: 'uppercase', ...other.style }}
            mask={mask}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

export const AccountNumberInputLocalPrepaid = ({ inputRef, ...other }) => {
    var mask = ['X', 'X', 'X', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            style={{ textTransform: 'uppercase', ...other.style }}
            mask={mask}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

export const AccountNumberInputForeignPrepaid = ({ inputRef, ...other }) => {
    var mask = ['X', 'X', 'X', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, 'F'];
    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            style={{ textTransform: 'uppercase', ...other.style }}
            mask={mask}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

class AboutCustomer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            account_no: props.defaultAccount.account_no || "",
            account_noState: props.defaultAccount.account_no ? (this.verifyAccountNo(props.defaultAccount.account_no) ? "success" : "error") : "",
            name: props.defaultAccount.name || "",
            nameState: props.defaultAccount.name ? "success" : "",
            registration_no: props.defaultAccount.registration_no || "",
            registration_noState: "",
            vat_no: props.defaultAccount.vat_no || "",
            vat_noState: "",
            country: props.defaultAccount.country || { label: "South Africa", value: "ZA" },
            countryState: "",
            sales: props.defaultAccount.sales || { label: 'None', value: '' },
            salesState: "",
            company: props.defaultAccount.company || "Cellfind",
            companyState: "",
            foreign: props.defaultAccount.foreign || false,
            image: props.defaultAccount.image || null
        };
        const { classes } = props;
        this.countryMenuItems = Countries.map(x => ({ label: x.name, value: x.code }))

        if(!props.defaultAccount.company)
            store.dispatch({ type: ADD_CUSTOMER_FORM_CHANGE, name: "company", payload: 'Cellfind' });

        if(!props.defaultAccount.country)
            store.dispatch({ type: ADD_CUSTOMER_FORM_CHANGE, name: "country", payload: { label: 'South Africa', value: 'ZA' } });
    }
    countryMenuItems = [];
    componentDidMount() {
        Api.get(UserEndpoints.list).then(({data}) => {
            store.dispatch({ type: SET_USER_LIST, payload: data });
        })
        .catch((e) => console.error(e))
    }
    sendState() {
        return this.state;
    }
    // function that returns true if value is email, false otherwise
    verifyEmail(value) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    }
    verifyAccountNo(value) {
        var accountNoRex = /^(XXX)*[A-Za-z0-9]{3}[0-9]{3}F*$/;
        if (accountNoRex.test(value)) {
            return true;
        }
        return false;
    }
    // function that verifies if a string has a given length or not
    verifyLength(value, length) {
        if (value.length >= length) {
            return true;
        }
        return false;
    }
    change(event, name, type = "required") {
        switch (type) {
            case "account_no":
                if (this.verifyAccountNo(event.target.value)) {
                    this.setState({ [name + "State"]: "success" });
                } else {
                    this.setState({ [name + "State"]: "error" });
                }
                this.setState({ [name]: event.target.value });
                store.dispatch({ type: ADD_CUSTOMER_FORM_CHANGE, name, payload: event.target.value.toUpperCase() });
                return;
            case "required":
                if (event.target.value) {
                    this.setState({ [name + "State"]: "success" });
                } else {
                    this.setState({ [name + "State"]: "error" });
                }
                break;
            case "country":
            case "sales":
                this.setState({ [name + "State"]: "success" });
                delete event.avatar;
                this.setState({ [name]: event });
                store.dispatch({ type: ADD_CUSTOMER_FORM_CHANGE, name, payload: event });
                return;
            default:
                break;
        }
        this.setState({ [name]: event.target.value });
        store.dispatch({ type: ADD_CUSTOMER_FORM_CHANGE, name, payload: event.target.value });
    }
    isValidated() {
        if (
            this.state.account_noState === "success" &&
            this.state.nameState === "success"
        ) {
            return true;
        } else {
            if (this.state.account_noState !== "success") {
                this.setState({ account_noState: "error" });
            }
            if (this.state.nameState !== "success") {
                this.setState({ nameState: "error" });
            }
        }
        return false;
    }
    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };
    uploadImage = file => {
        Api.fileUpload(ImageEndpoints.upload, [file])
            .then(({ data }) => {
                this.setState({ ...data })
                store.dispatch({ type: ADD_CUSTOMER_FORM_CHANGE, name: 'image', payload: data.image });
            })
    }
    accountNoChanged(event, name) {
        if (name === "foreign") {
            var newAccountNo = (this.props.isPrepaid ?
                /^XXX/.test(event.target.checked ? /F$/.test(this.state.account_no) ? this.state.account_no : this.state.account_no + "F" : this.state.account_no.replace(/F$/, ""))
                    ?
                    (event.target.checked ? /F$/.test(this.state.account_no) ? this.state.account_no : this.state.account_no + "F" : this.state.account_no.replace(/F$/, ""))
                    :
                    ("XXX" + (event.target.checked ? /F$/.test(this.state.account_no) ? this.state.account_no : this.state.account_no + "F" : this.state.account_no.replace(/F$/, "")))
                :
                (event.target.checked ? /F$/.test(this.state.account_no) ? this.state.account_no : this.state.account_no + "F" : this.state.account_no.replace(/F$/, "")).replace(/^XXX/, "")
            ).toUpperCase();

            store.dispatch({
                type: ADD_CUSTOMER_FORM_CHANGE,
                name: "account_no",
                payload: newAccountNo
            });

            this.setState({ account_no: newAccountNo });
        }
        else if (name === "prepaid") {
            var newAccountNo = (event.target.checked ?
                /^XXX/.test((this.state.foreign ? /F$/.test(this.state.account_no) ? this.state.account_no : this.state.account_no + "F" : this.state.account_no.replace(/F$/, "")))
                    ?
                    (this.state.foreign ? /F$/.test(this.state.account_no) ? this.state.account_no : this.state.account_no + "F" : this.state.account_no.replace(/F$/, ""))
                    :
                    ("XXX" + (this.state.foreign ? /F$/.test(this.state.account_no) ? this.state.account_no : this.state.account_no + "F" : this.state.account_no.replace(/F$/, "")))
                :
                (this.state.foreign ? /F$/.test(this.state.account_no) ? this.state.account_no : this.state.account_no + "F" : this.state.account_no.replace(/F$/, "")).replace(/^XXX/, "")
            ).toUpperCase();

            store.dispatch({
                type: ADD_CUSTOMER_FORM_CHANGE,
                name: "account_no",
                payload: newAccountNo
            });

            store.dispatch({
                type: ADD_CUSTOMER_FORM_CHANGE,
                name: "prepaid",
                payload: (event.target.checked)
            });

            this.setState({ account_no: newAccountNo });
        }
    }
    render() {
        const { classes } = this.props;
        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={12}>
                    <h4 className={classes.infoText}>
                        Basic Customer Information
                    </h4>
                </GridItem>
                <GridItem xs={12} sm={3} md={3} lg={3}>
                    <PictureUpload
                        preview={this.state.image ? ("/api/image/get?id=" + this.state.image) : null}
                        onImagePicked={(file) => this.uploadImage(file)}
                    />
                </GridItem>
                <GridItem xs={12} sm={8} md={8} lg={8}>
                    <CustomInput
                        success={this.state.account_noState === "success"}
                        error={this.state.account_noState === "error"}
                        labelText={
                            <span>
                                Account Number <small>(required)</small>
                            </span>
                        }
                        id="account_no"
                        formControlProps={{
                            fullWidth: true
                        }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                            onChange: event => this.change(event, "account_no", "account_no"),
                            // endAdornment: (
                            //     <InputAdornment
                            //         position="end"
                            //         className={classes.inputAdornment}
                            //     >
                            //         <Email className={classes.inputAdornmentIcon} />
                            //     </InputAdornment>
                            // )
                            value: this.state.account_no,
                            inputComponent: this.state.foreign ? (this.props.isPrepaid ? AccountNumberInputForeignPrepaid : AccountNumberInputForeign) : (this.props.isPrepaid ? AccountNumberInputLocalPrepaid : AccountNumberInputLocal)
                        }}
                    />
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={6} md={6} lg={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={this.state.foreign}
                                        onChange={(event) => {
                                            this.accountNoChanged(event, "foreign");
                                            this.handleChange("foreign")(event);
                                        }}
                                        value={this.state.foreign}
                                        //color="rose"
                                        classes={{
                                            switchBase: classes.switchBase,
                                            checked: classes.switchChecked,
                                            icon: classes.switchIcon,
                                            iconChecked: classes.switchIconChecked,
                                            bar: classes.switchBar
                                        }}
                                    />
                                }
                                classes={{
                                    label: classes.label
                                }}
                                label="Foreign Account?"
                            />
                        </GridItem>
                        <GridItem xs={12} sm={6} md={6} lg={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={this.props.isPrepaid}
                                        onChange={(event) => {
                                            // if(event.target.checked)
                                            //     this.setState({ account_no: "XXX" + this.state.account_no })
                                            // else
                                            //     this.setState({ account_no: this.state.account_no.replace(/^XXX/, "") })
                                            this.accountNoChanged(event, "prepaid");
                                            this.props.onPrepaidChange(event.target.checked)
                                        }}
                                        value={this.props.isPrepaid}
                                        //color="rose"
                                        classes={{
                                            switchBase: classes.switchBase,
                                            checked: classes.switchChecked,
                                            icon: classes.switchIcon,
                                            iconChecked: classes.switchIconChecked,
                                            bar: classes.switchBar
                                        }}
                                    />
                                }
                                classes={{
                                    label: classes.label
                                }}
                                label="Prepaid Account?"
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={10} lg={10}>
                    <CustomInput
                        success={this.state.nameState === "success"}
                        error={this.state.nameState === "error"}
                        labelText={
                            <span>
                                Customer Name <small>(required)</small>
                            </span>
                        }
                        id="name"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "name"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <CardTravel className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.name,
                        }}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={10} lg={10}>
                    <CustomInput
                        success={this.state.registration_noState === "success"}
                        error={this.state.registration_noState === "error"}
                        labelText={
                            <span>
                                Registration Number
                            </span>
                        }
                        id="registration_no"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "registration_no", "optional"),
                            value: this.state.registration_no,
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <AccountBalance className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            )
                        }}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={10} lg={10}>
                    <CustomInput
                        success={this.state.vat_noState === "success"}
                        error={this.state.vat_noState === "error"}
                        labelText={
                            <span>
                                VAT Number
                            </span>
                        }
                        id="vat_no"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "vat_no", "optional"),
                            value: this.state.vat_no,
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <AccountBalance className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            )
                        }}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={10} lg={10}>
                    <ReactSelect
                        label="Country"
                        options={this.countryMenuItems}
                        value={this.state.country}
                        onChange={(event) => this.change(event, "country", 'country')}
                        isSearchable
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={10} lg={10}>
                    <ReactSelect
                        label="Sales Representative"
                        options={this.props.users ? [{ label: 'None', value: '' }].concat(this.props.users.map(u => ({ label: u.name + (u.surname ? " " + u.surname : ''), avatar: <UserImage {...u} />, value: u.id }))) : { label: "Loading...", value: '' }}
                        value={this.state.sales}
                        onChange={(event) => this.change(event, "sales", "sales")}
                        isSearchable
                        isLoading={!Boolean(this.props.users)}
                        isDisabled={!Boolean(this.props.users)}
                    />
                    {/* <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                    >
                        <InputLabel
                            htmlFor="sales"
                            className={classes.selectLabel}
                            shrink
                        >
                            Sales Representative
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu
                            }}
                            classes={{
                                select: classes.select
                            }}
                            value={this.state.sales}
                            onChange={(event) => this.change(event, "sales")}
                            inputProps={{
                                name: "sales",
                                id: "sales"
                            }}
                            color="rose"
                        >
                            <MenuItem disabled classes={{ root: classes.selectMenuItem }}>Choose a Sales Rep</MenuItem>
                        </Select>
                    </FormControl> */}
                </GridItem>
                <GridItem xs={12} sm={12} md={10} lg={10}>
                    <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                    >
                        <InputLabel
                            htmlFor="company"
                            className={classes.selectLabel}
                            shrink
                        >
                            Company / Legal Entity
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu
                            }}
                            classes={{
                                select: classes.select
                            }}
                            value={this.state.company}
                            onChange={(event) => this.change(event, "company")}
                            inputProps={{
                                name: "company",
                                id: "company"
                            }}
                            color="rose"
                        >
                            <MenuItem disabled classes={{ root: classes.selectMenuItem }}>Choose Company</MenuItem>
                            <MenuItem
                                classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                }}
                                value="Cellfind">
                                Cellfind
                            </MenuItem>
                            <MenuItem
                                classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                }}
                                value="Panacea">
                                Panacea
                            </MenuItem>
                            <MenuItem
                                classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                }}
                                value="Simigenix">
                                Simigenix
                            </MenuItem>
                        </Select>
                    </FormControl>
                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(AboutCustomer);
